import { hydrateRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"

import { App } from "./App"
import { createStore } from "./redux"

const renderMethod = hydrateRoot

const preloadedStateElement = document.getElementById("preloaded-redux-state")
const serverState = preloadedStateElement?.textContent
  ? JSON.parse(preloadedStateElement.textContent)
  : undefined
const store = createStore(serverState)

const root = document.getElementById("root")

if (!root) throw new Error("No root element found")

renderMethod(
  root,
  <BrowserRouter>
    <Provider store={store} serverState={serverState}>
      <App />
    </Provider>
  </BrowserRouter>,
)

import.meta.hot
  ? console.debug("Client entrypoint rendered react tree")
  : console.debug("Client entrypoint hydrated react tree")
